var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import MuiTextField from '@mui/material/TextField';
import { useIMask } from 'react-imask';
/** Extends MUI's TextField component with masking functionality */
const TextField = forwardRef((_a, ref) => {
    var { mask, inputRef } = _a, rest = __rest(_a, ["mask", "inputRef"]);
    const { ref: maskRef = null } = useIMask(mask ? mask : { mask: '' });
    return (_jsx(MuiTextField, Object.assign({ ref: ref, inputRef: inputRef ? inputRef : mask ? maskRef : undefined }, rest)));
});
export default TextField;
